import React, { ReactNode } from 'react';
import { QueryProvider } from '../services/providers/QueryProvider';
import { AuthProvider } from '../contexts/AuthContext';
import { LoggingProvider } from '../contexts/LoggingContext';
import ErrorBoundary from '../components/ErrorBoundary';

interface AppProvidersProps {
    children: ReactNode;
}

/**
 * Centralized provider wrapper that combines all app-level providers
 * in the correct order for proper dependency management.
 *
 * Provider Order (outer to inner):
 * 1. QueryProvider - React Query for API state management
 * 2. AuthProvider - Authentication and user context
 * 3. ErrorBoundary - Global error handling with CloudWatch integration
 * 4. LoggingProvider - CloudWatch logging context
 * 5. Children - Your app components
 */
export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
    return (
        <QueryProvider>
            <AuthProvider>
                <LoggingProvider>
                    <ErrorBoundary>{children}</ErrorBoundary>
                </LoggingProvider>
            </AuthProvider>
        </QueryProvider>
    );
};

export default AppProviders;
